module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-5-Positive-Affirmations-645972a7eac6299a35179c30e1364f22.pdf";